import { decode } from 'js-base64';
import { NotificationCard } from '../../components/Card';
import { Center, Flex, Icon } from '@chakra-ui/react';
import { NotificationTime } from '../../components/Time';
import { Calendar } from '@kula-ai/icons/outline/Calendar';
import {
  ConfirmRSVPButtons,
  MeetingDetailsContainer,
  NotificationMessage,
  ReviewCandidateButton,
} from './components';

const ConfirmRSVP = ({ notification = {}, onClose = () => {} }) => {
  const { custom_attributes } = notification;
  const data = JSON.parse(decode(custom_attributes));

  const { candidate, interview_name, interview_url, is_mscal_shared_calendar } =
    data || {};
  const interview_id = interview_url.split('/').pop();
  const isMsCalSharedCalendar =
    is_mscal_shared_calendar === true ? true : false;

  const { name: candidateName, url } = candidate;
  const contact_id = url.split('/').pop();

  const messageData = {
    interview: { name: interview_name, url: `/interviews/${interview_id}` },
    candidate: { name: candidateName, url: `/candidates/${contact_id}` },
  };

  return (
    <Flex alignItems="baseline" gap="6px">
      <Center minW="34px" h="34px" borderRadius="sm" bg="primary-100">
        <Icon as={Calendar} color="primary-500" width="16px" />
      </Center>
      <Flex flexDir="column" ml="16px" gap="8px" alignSelf="start">
        <NotificationMessage
          template="RSVP_REMINDER"
          data={messageData}
          onClose={onClose}
          notification={notification}
        />
        <MeetingDetailsContainer data={data} />
        {isMsCalSharedCalendar === false && (
          <Flex flexDir="column" gap="6px">
            <ConfirmRSVPButtons
              interviewUrl={interview_url}
              notification={notification}
            />
            <ReviewCandidateButton
              interviewUrl={interview_url}
              notification={notification}
            />
          </Flex>
        )}
        <NotificationTime notification={notification} />
      </Flex>
    </Flex>
  );
};

export const ConfirmRSVPNotification = ({
  notification = {},
  onClose = () => {},
}) => {
  return (
    <NotificationCard notification={notification}>
      <ConfirmRSVP notification={notification} onClose={onClose} />
    </NotificationCard>
  );
};
